import mixin from "./src";
mixin.install = function(Vue) {
  Vue.mixin(mixin);
};
export default mixin;
